import prepareFilterData from '../../filter-common/prepareFilterData'
import { startLoader, stopLoader } from '../../filter-common/filterLoaders'
import { getPage } from '../../api/search-results'
import { updateUrlParam } from '../../url-params/url-params'
import { getSortingParams } from '../../filter-common/sortingResults'
import { LazyLoadImages } from '../../lazy-loading/LazyLoadImages'

export default class FilterResults {
    constructor(hideBulletPoints) {
        this.page = 1
        this.isLoading = true
        this.hideBulletPoints = hideBulletPoints
        this.productListing = document.getElementById('product_listing')
        this.productCountContainer = document.getElementById('product_listing_count')
        this.paginationContainer = document.getElementById('pagination')
        this.hostOrigin = window.location.origin
        this.totalPages = 1
    }

    generateFeature(feature) {
        const featureWrapper = document.createElement('li')
        let featureKey = this.cutBR(feature.key)
        const featureValue = feature.value
        const featureUnit = feature.unit
        const featureType = typeof featureValue
        let transformedValue = ''
        if (featureType === 'object') {
            for (let [key, value] of Object.entries(featureValue)) {
                if (key === 'min') {
                    transformedValue += `${value} - `
                } else if (key === 'max') {
                    transformedValue += `${value}`
                } else {
                    transformedValue += `${value}, `
                }
            }
        } else {
            transformedValue = featureValue
        }
        transformedValue = transformedValue.replace(/(,\s?)$/g, '')
        if (typeof featureUnit === 'string' && featureUnit.length > 0) {
            transformedValue += ` ${featureUnit}`
        }
        featureKey = this.cutBR(featureKey)
        transformedValue = this.cutBR(transformedValue)

        featureWrapper.setAttribute('title', `${featureKey}: ${transformedValue}`)
        featureWrapper.innerHTML = `${featureKey}: ${transformedValue}`

        return featureWrapper
    }

    generateProductImage(product) {
        const productImageWrapper = document.createElement('a')
        productImageWrapper.classList.add('item-image')
        if (product.rental == true) {
            const rentalImageTag = document.createElement('span')
            rentalImageTag.classList.add('rental-image-tag')
            const rentalImage = document.createElement('img')
            rentalImage.setAttribute('data-src', this.productListing.getAttribute('data-rentalIcon'))
            rentalImage.setAttribute('alt', this.productListing.getAttribute('data-rentalIconAltText'));
            rentalImageTag.appendChild(rentalImage)
            productImageWrapper.appendChild(rentalImageTag)
        }
        productImageWrapper.href = this.generateProductUrl(product.url)
        const productImage = document.createElement('img')
        productImage.classList.add('image', 'lazy')
        productImage.setAttribute('data-src', product.image)
        productImage.setAttribute('alt', product.imageAlt)
        productImage.setAttribute('width', '300')
        productImage.setAttribute('height', '300')
        productImageWrapper.appendChild(productImage)
        return productImageWrapper
    }

    generateProductDescription(product) {
        const text = product.listingText
        const attributes = product.listingAttributes
        const name = product.name
        const hasProductText = text !== ''
        const hasAttributes = attributes.length > 0

        const productDescWrapper = document.createElement('div')
        productDescWrapper.classList.add('item-desc')
        const aProductName = document.createElement('a')
        aProductName.href = this.generateProductUrl(product.url)
        const productName = document.createElement('h2')
        productName.classList.add('item-name')
        productName.innerHTML = name
        aProductName.appendChild(productName)
        productDescWrapper.appendChild(aProductName)

        if (hasProductText || hasAttributes) {
            const scrollWrapper = document.createElement('div')
            scrollWrapper.classList.add('scrollable-group')
            if (hasProductText) {
                const textElem = document.createElement('div')
                textElem.classList.add('item-text')
                textElem.innerHTML = text
                scrollWrapper.appendChild(textElem)
            }
            if (hasAttributes) {
                const listElem = document.createElement('ul')
                listElem.classList.add('item-features')
                if (!this.hideBulletPoints) {
                    listElem.classList.add('with-bullet')
                }
                attributes.map((attr) => {
                    listElem.appendChild(this.generateFeature(attr))
                })
                scrollWrapper.appendChild(listElem)
            }
            productDescWrapper.appendChild(scrollWrapper)
        } else {
            const emptyElem = document.createElement('div')
            emptyElem.classList.add('item-empty')
            productDescWrapper.appendChild(emptyElem)
        }

        return productDescWrapper
    }

    generateProductButton(product) {
        const productButtonWrapper = document.createElement('div')
        productButtonWrapper.classList.add('item-button')
        const productButton = document.createElement('a')
        productButton.classList.add('button')
        productButton.href = this.generateProductUrl(product.url)
        productButton.innerHTML = `${window.globals.trans('filter.view_product')}`
        productButtonWrapper.appendChild(productButton)
        return productButtonWrapper
    }

    generateProductUrl(url) {
        const params = window.location.href.split('#')[1] || ''
        const newUrl = `${url}#${params}`
        return newUrl
    }

    generateProduct(product) {
        const pWrapper = document.createElement('div')
        pWrapper.classList.add('product-wrapper')
        pWrapper.setAttribute('data-product-id', product.id)
        const pUrl = document.createElement('div')
        pUrl.classList.add('item')
        const pImage = this.generateProductImage(product)
        const pDescription = this.generateProductDescription(product)
        const pPriceButtonWrapper = this.generatePriceButtonWrapper()
        const pPrice = this.generateProductPrice(product)
        const pButton = this.generateProductButton(product)

        pUrl.appendChild(pImage)
        pUrl.appendChild(pDescription)
        pUrl.appendChild(pPriceButtonWrapper)
        pPriceButtonWrapper.appendChild(pPrice)
        pPriceButtonWrapper.appendChild(pButton)
        pWrapper.appendChild(pUrl)

        return pWrapper
    }

    generatePriceButtonWrapper() {
        const wrapper = document.createElement('div')
        wrapper.classList.add('item-price-button-wrapper')
        return wrapper
    }

    generateProductPrice(product) {
        const priceElement = document.createElement('div')
        priceElement.classList.add('item-price')
        priceElement.innerHTML =
            product.minPrice && product.minPrice !== '' ? `<span>${window.globals.trans('filter.min_price')}</span> ${product.minPrice}` : `&nbsp`
        return priceElement
    }

    generateProductsList(productsData) {
        if (productsData.length > 0) {
            productsData.map((product) => {
                this.productListing.appendChild(this.generateProduct(product))
            })
            new LazyLoadImages(this.productListing)
        } else {
            const noResults = document.createElement('div')
            noResults.classList.add('col-12')
            noResults.classList.add('text-center')
            noResults.innerHTML = `${window.globals.trans('filter.no_results')}`
            this.productListing.appendChild(noResults)
        }
    }

    generateTotalCount(totalCount) {
        this.productCountContainer.innerHTML = totalCount
    }

    render(productsData, totalCount, perPage, initialPage = 1) {
        this.page = initialPage
        this.totalPages = Math.ceil(totalCount / perPage) || 1
        this.productListing.innerHTML = ''
        this.generateTotalCount(totalCount)
        this.generateProductsList(productsData)
        this.generatePagination(this.page, this.totalPages)
    }

    getPageRange(currentPage, totalPages) {
        if (totalPages <= 7) {
            return Array.from({ length: totalPages }, (_, i) => i + 1)
        }
        if (currentPage <= 4) {
            return [1, 2, 3, 4, 5, '...', totalPages]
        }
        if (currentPage >= totalPages - 3) {
            return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
        }
        return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages]
    }

    generatePagination(currentPage, totalPages) {
        if (!this.paginationContainer) return
        this.paginationContainer.innerHTML = ''
        if (totalPages <= 1) return

        const nav = document.createElement('nav')
        nav.setAttribute('aria-label', 'Product pagination')

        const ul = document.createElement('ul')
        ul.classList.add('pagination')

        // Previous button
        const prevLi = document.createElement('li')
        prevLi.classList.add('page-item')
        const prevBtn = document.createElement('button')
        prevBtn.classList.add('page-link', 'page-prev')
        prevBtn.setAttribute('aria-label', 'Previous')
        prevBtn.innerHTML = '&lt;'
        if (currentPage === 1) {
            prevLi.classList.add('disabled')
            prevBtn.setAttribute('disabled', '')
        } else {
            prevBtn.addEventListener('click', () => this.goToPage(currentPage - 1))
        }
        prevLi.appendChild(prevBtn)
        ul.appendChild(prevLi)

        // Page number buttons
        this.getPageRange(currentPage, totalPages).forEach((item) => {
            const li = document.createElement('li')
            li.classList.add('page-item')
            if (item === '...') {
                li.classList.add('disabled')
                const span = document.createElement('span')
                span.classList.add('page-link')
                span.innerHTML = '&hellip;'
                li.appendChild(span)
            } else {
                if (item === currentPage) li.classList.add('active')
                const btn = document.createElement('button')
                btn.classList.add('page-link')
                btn.textContent = item
                if (item !== currentPage) {
                    btn.addEventListener('click', () => this.goToPage(item))
                }
                li.appendChild(btn)
            }
            ul.appendChild(li)
        })

        // Next button
        const nextLi = document.createElement('li')
        nextLi.classList.add('page-item')
        const nextBtn = document.createElement('button')
        nextBtn.classList.add('page-link', 'page-next')
        nextBtn.setAttribute('aria-label', 'Next')
        nextBtn.innerHTML = '&gt;'
        if (currentPage === totalPages) {
            nextLi.classList.add('disabled')
            nextBtn.setAttribute('disabled', '')
        } else {
            nextBtn.addEventListener('click', () => this.goToPage(currentPage + 1))
        }
        nextLi.appendChild(nextBtn)
        ul.appendChild(nextLi)

        nav.appendChild(ul)
        this.paginationContainer.appendChild(nav)
    }

    goToPage(pageNo) {
        if (pageNo < 1 || pageNo > this.totalPages || pageNo === this.page) return
        this.page = pageNo
        updateUrlParam('page', pageNo)
        startLoader('results-loader')
        const fData = { ...prepareFilterData(), ...getSortingParams() }
        getPage(pageNo, fData)
            .then((data) => {
                stopLoader('results-loader')
                const resData = data.data.data
                this.productListing.innerHTML = ''
                this.generateProductsList(resData.products)
                this.generateTotalCount(resData.total)
                this.totalPages = Math.ceil(resData.total / resData.perPage) || 1
                this.generatePagination(pageNo, this.totalPages)
                this.scrollToListing()
            })
            .catch((err) => {
                stopLoader('results-loader')
                console.log(err)
            })
    }

    scrollToListing() {
        const listing = document.querySelector('.product-listing')
        if (listing) {
            const offset = listing.getBoundingClientRect().top + window.pageYOffset - 100
            window.scrollTo({ top: offset, behavior: 'smooth' })
        }
    }

    cutBR(text) {
        return text.toString().replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, ' ')
    }
}
